import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export default makeStyles((theme: Theme) =>
    createStyles({
        root: {
            borderRadius: '16px'
        },
        button: {
            textTransform: 'none',
            color: 'var(--white-color)',
            backgroundColor: 'var(--blue700)',
            borderRadius: 32,
            height: '44px',
            fontFamily: 'NouvelleNormal',
            margin: '16px'
        },
        expandMore: {
            display: 'flex',
            width: '20px',
            height: '20px',
            borderRadius: '4px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        expandMoreIcon: {
            color: 'var(--white-color)'
        },
        dialogTitle: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            height: '55px'
        },
        closeButton: {
            width: '25px',
            height: '25px'
        },
        title: {
            fontFamily: 'NouvelleBold',
            '@global': {
                span: {
                    fontFamily: 'MorangaRg !important',
                    color: '#3A66FF'
                }
            },
        }
    })
)